<template>
  <svg
    width="160"
    height="29"
    viewBox="0 0 160 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="logo" clip-path="url(#clip0_1500_402903)">
      <path
        id="Layer"
        d="M12.739 4.22105C11.7638 4.22105 10.9409 3.38328 10.9409 2.35217C10.9409 1.32105 11.7638 0.483276 12.739 0.483276C13.7143 0.483276 14.5066 1.32105 14.5066 2.35217C14.5066 3.38328 13.7143 4.22105 12.739 4.22105Z"
        fill="black"
      />
      <path
        id="Layer_2"
        d="M15.0248 10.4078V7.41117C15.0248 6.05784 13.9886 4.96228 12.739 4.96228C11.459 4.96228 10.4229 6.05784 10.4229 7.41117V10.4078H15.0248Z"
        fill="black"
      />
      <path
        id="Layer_3"
        d="M14.2324 11.89H11.2458L9.75244 14.6289L11.2458 17.3356H14.2324L15.7258 14.6289L14.2324 11.89Z"
        fill="#00A8E8"
      />
      <path
        id="Layer_4"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M107.368 19.2045H99.4742L98.1028 22.8456H95.9695L102.217 6.41223H104.594L110.872 22.8456H108.739L107.368 19.2045ZM100.053 17.3678H106.789L103.436 8.2489L100.053 17.3678Z"
        fill="black"
      />
      <path
        id="Layer_5"
        d="M112.64 19.8489C113.493 20.7834 115.109 21.5889 116.815 21.5889C118.766 21.5889 119.832 20.7512 119.832 19.5589C119.832 18.2378 118.278 17.8189 116.571 17.4001C114.408 16.9167 111.97 16.3689 111.97 13.8556C111.97 11.9545 113.676 10.3434 116.693 10.3434C118.857 10.3434 120.381 11.1167 121.387 12.0834L120.472 13.4045C119.71 12.5345 118.309 11.8578 116.693 11.8578C114.956 11.8578 113.89 12.6312 113.89 13.7267C113.89 14.8867 115.322 15.2734 116.998 15.6601C119.192 16.1434 121.752 16.7556 121.752 19.4301C121.752 21.4923 120.046 23.1356 116.754 23.1356C114.682 23.1356 112.914 22.5234 111.634 21.2023L112.64 19.8489Z"
        fill="black"
      />
      <path
        id="Layer_6"
        d="M124.587 19.8489C125.41 20.7834 127.025 21.5889 128.731 21.5889C130.682 21.5889 131.749 20.7512 131.749 19.5589C131.749 18.2378 130.194 17.8189 128.488 17.4001C126.324 16.9167 123.886 16.3689 123.886 13.8556C123.886 11.9545 125.592 10.3434 128.61 10.3434C130.773 10.3434 132.297 11.1167 133.303 12.0834L132.389 13.4045C131.627 12.5345 130.255 11.8578 128.61 11.8578C126.872 11.8578 125.806 12.6312 125.806 13.7267C125.806 14.8867 127.238 15.2734 128.914 15.6601C131.109 16.1434 133.669 16.7556 133.669 19.4301C133.669 21.4923 131.962 23.1356 128.671 23.1356C126.598 23.1356 124.831 22.5234 123.551 21.2023L124.556 19.8489H124.587Z"
        fill="black"
      />
      <path
        id="Layer_7"
        d="M136.229 7.3144C136.229 6.60551 136.838 6.02551 137.539 6.02551C138.24 6.02551 138.88 6.60551 138.88 7.3144C138.88 8.02329 138.27 8.60329 137.539 8.60329C136.808 8.60329 136.229 8.02329 136.229 7.3144ZM136.564 10.6333H138.545V22.8133H136.564V10.6333Z"
        fill="black"
      />
      <path
        id="Layer_8"
        d="M142.11 19.8489C142.933 20.7834 144.549 21.5889 146.286 21.5889C148.236 21.5889 149.272 20.7512 149.272 19.5589C149.272 18.2378 147.718 17.8189 146.011 17.4001C143.848 16.9167 141.409 16.3689 141.409 13.8556C141.409 11.9545 143.116 10.3434 146.133 10.3434C148.297 10.3434 149.821 11.1167 150.857 12.0834L149.912 13.4045C149.15 12.5345 147.779 11.8578 146.133 11.8578C144.396 11.8578 143.329 12.6312 143.329 13.7267C143.329 14.8867 144.792 15.2734 146.438 15.6601C148.632 16.1434 151.192 16.7556 151.192 19.4301C151.192 21.4923 149.486 23.1356 146.194 23.1356C144.122 23.1356 142.354 22.5234 141.074 21.2023L142.11 19.8489Z"
        fill="black"
      />
      <path
        id="Layer_9"
        d="M153.63 10.6333V7.31445H155.581V10.6333H159.025V12.3089H155.581V19.8811C155.581 20.7833 156.008 21.4278 156.861 21.4278C157.41 21.4278 157.958 21.2022 158.202 20.9445L158.781 22.3622C158.293 22.8133 157.592 23.1356 156.434 23.1356C154.545 23.1356 153.6 22.1045 153.6 20.2678V10.6333H153.63Z"
        fill="black"
      />
      <path
        id="Layer_10"
        d="M34.9867 6.54114H47.0248C47.3905 6.54114 47.6952 6.86336 47.6952 7.25003V8.3778C47.6952 8.76447 47.3905 9.15114 47.0248 9.15114H37.8819C37.5162 9.15114 37.2114 9.40892 37.2114 9.79558V12.6311C37.2114 13.0178 37.5162 13.34 37.8819 13.34H46.141C46.5067 13.34 46.8114 13.6622 46.8114 14.0489V15.1767C46.8114 15.5634 46.5067 15.8856 46.141 15.8856H37.8819C37.5162 15.8856 37.2114 16.2078 37.2114 16.5945V19.5267C37.2114 19.9456 37.5162 20.2678 37.8819 20.2678H47.0248C47.3905 20.2678 47.6952 20.5578 47.6952 20.9445V22.1045C47.6952 22.4911 47.3905 22.8134 47.0248 22.8134H34.9867C34.5905 22.8134 34.2552 22.4589 34.2552 22.04V7.31447C34.2552 6.89558 34.5905 6.54114 34.9867 6.54114Z"
        fill="black"
      />
      <path
        id="Layer_11"
        d="M49.5238 20.6545C49.5238 20.4289 49.6457 20.2356 49.7676 20.0745C49.7676 20.0745 58.1486 10.3111 58.4838 9.79558C58.6971 9.47336 58.6362 9.15114 58.3009 9.15114C57.6305 9.15114 50.2248 9.15114 50.2248 9.15114C49.859 9.15114 49.5543 8.82892 49.5543 8.44225V7.31447C49.5543 6.89558 49.859 6.54114 50.2248 6.54114H62.2628C62.659 6.54114 62.9638 6.86336 62.9638 7.28225V8.63558C62.9638 8.99003 62.8114 9.2478 62.5676 9.5378L54.0343 19.8167C53.8819 20.0422 53.9733 20.2356 54.2171 20.2356H62.2933C62.659 20.2356 62.9638 20.5578 62.9638 20.9445V22.1045C62.9638 22.4911 62.659 22.8134 62.2933 22.8134L50.2248 22.8456C49.859 22.8456 49.5543 22.5234 49.5543 22.1045V20.6545H49.5238Z"
        fill="#00A8E8"
      />
      <path
        id="Layer_12"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M87.5886 18.56L88.7162 19.3012C89.0514 19.5267 89.1124 20.01 88.899 20.3323C87.8629 21.9112 86.1257 23.0067 83.9314 23.0067C80.3352 23.0067 77.9276 20.0745 77.9276 16.7556V16.53C77.9276 13.2434 80.3352 10.3112 83.9314 10.3112C87.5276 10.3112 89.9352 13.2434 89.9352 16.53C89.9352 16.5945 89.9352 16.8845 89.9352 16.9167C89.9352 17.3678 89.5695 17.7545 89.1429 17.7545H81.5543C81.1886 17.7545 80.9752 18.1412 81.1276 18.4634C81.6152 19.4945 82.5905 20.2678 83.9314 20.2678C85.12 20.2678 86.0343 19.6556 86.5524 18.8178C86.7962 18.4312 87.2228 18.3345 87.5886 18.56ZM81.1886 14.7578C80.9752 15.1123 81.219 15.5634 81.6152 15.5634H86.2476C86.6438 15.5634 86.8876 15.1123 86.7048 14.7578C86.1867 13.7912 85.2419 13.05 83.9314 13.05C82.6209 13.05 81.6762 13.7912 81.1886 14.7578Z"
        fill="#00A8E8"
      />
      <path
        id="Layer_13"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M73.9048 18.56L75.0324 19.3012C75.3676 19.5267 75.4591 20.01 75.2152 20.3323C74.2095 21.9112 72.4419 23.0067 70.2781 23.0067C66.6819 23.0067 64.2743 20.0745 64.2743 16.7556V16.53C64.2743 13.2434 66.6819 10.3112 70.2781 10.3112C73.8743 10.3112 76.2819 13.2434 76.2819 16.53C76.2819 16.5945 76.2819 16.8845 76.2819 16.9167C76.2514 17.3678 75.9162 17.7545 75.4591 17.7545H67.8705C67.5352 17.7545 67.2914 18.1412 67.4438 18.4634C67.9619 19.4945 68.9067 20.2678 70.2781 20.2678C71.4667 20.2678 72.3505 19.6556 72.8991 18.8178C73.1124 18.4312 73.5695 18.3345 73.9048 18.56ZM67.5048 14.7578C67.3219 15.1123 67.5657 15.5634 67.9619 15.5634H72.5943C72.9905 15.5634 73.2343 15.1123 73.021 14.7578C72.5333 13.7912 71.5581 13.05 70.2781 13.05C68.9676 13.05 68.0229 13.7912 67.5048 14.7578Z"
        fill="#00A8E8"
      />
      <path
        id="Layer_14"
        d="M12.7391 28.7744C11.7638 28.7744 10.9714 27.9366 10.9714 26.9055C10.9714 25.8422 11.7638 25.0044 12.7391 25.0044C13.7143 25.0044 14.5371 25.8422 14.5371 26.9055C14.5371 27.9366 13.7143 28.7744 12.7391 28.7744Z"
        fill="black"
      />
      <path
        id="Layer_15"
        d="M10.4534 18.85V21.8466C10.4534 23.1677 11.4896 24.2633 12.7391 24.2633C14.0191 24.2633 15.0553 23.1677 15.0248 21.8466V18.8177L10.4534 18.85Z"
        fill="black"
      />
      <path
        id="Layer_16"
        d="M2.68193 10.3756C1.70669 10.3756 0.914307 9.53781 0.914307 8.47448C0.914307 7.44337 1.70669 6.60559 2.68193 6.60559C3.65716 6.60559 4.48002 7.44337 4.48002 8.47448C4.48002 9.53781 3.65716 10.3756 2.68193 10.3756Z"
        fill="black"
      />
      <path
        id="Layer_17"
        d="M10.4228 10.4078L7.98473 8.92561C6.88759 8.24895 5.45521 8.63561 4.84568 9.79561C4.20568 10.9556 4.5714 12.4378 5.66854 13.1145L8.13711 14.6289L10.4228 10.4078Z"
        fill="black"
      />
      <path
        id="Layer_18"
        d="M22.7962 22.62C21.8209 22.62 21.0286 21.7822 21.0286 20.7511C21.0286 19.72 21.8209 18.85 22.7962 18.85C23.7714 18.85 24.5638 19.72 24.5638 20.7511C24.5638 21.7822 23.7714 22.62 22.7962 22.62Z"
        fill="black"
      />
      <path
        id="Layer_19"
        d="M15.0553 18.85L17.4934 20.3322C18.5905 21.0089 20.0229 20.59 20.6324 19.43C21.2724 18.27 20.9067 16.7878 19.8096 16.1111L17.341 14.6289L15.0553 18.85Z"
        fill="black"
      />
      <path
        id="Layer_20"
        d="M2.68193 22.6522C1.70669 22.6522 0.914307 21.7822 0.914307 20.7511C0.914307 19.72 1.70669 18.8822 2.68193 18.8822C3.68764 18.8822 4.48002 19.72 4.48002 20.7511C4.48002 21.7822 3.68764 22.6522 2.68193 22.6522Z"
        fill="black"
      />
      <path
        id="Layer_21"
        d="M8.13711 14.6289L5.66854 16.1111C4.5714 16.7878 4.20568 18.27 4.84568 19.43C5.48568 20.6222 6.88759 21.0089 7.98473 20.3322L10.4533 18.85L8.13711 14.6289Z"
        fill="black"
      />
      <path
        id="Layer_22"
        d="M22.7961 10.3434C21.7904 10.3434 20.998 9.50559 20.998 8.47448C20.998 7.44337 21.7904 6.60559 22.7961 6.60559C23.7714 6.60559 24.5638 7.44337 24.5638 8.47448C24.5638 9.50559 23.7714 10.3434 22.7961 10.3434Z"
        fill="#00A8E8"
      />
      <path
        id="Layer_23"
        d="M17.341 14.6289L19.8096 13.1144C20.9067 12.4378 21.2724 10.9556 20.6324 9.79556C19.9924 8.63556 18.5905 8.24889 17.4934 8.89334L15.0553 10.4078L17.341 14.6289Z"
        fill="#00A8E8"
      />
    </g>
    <defs>
      <clipPath id="clip0_1500_402903">
        <rect width="160" height="29" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
